export const contactInfo = {
  address: 'Rambla de Catalunya, 85, Principal - 2',
  city: 'Barcelona',
  postalCode: '08008',
  region: 'Cataluña',
  country: 'España',
  phone: '+34 625 46 34 20',
  email: 'anthosanchez3108@gmail.com',
  hours: {
    altaCostura: {
      label: 'Consultas Alta Costura',
      schedule: 'Martes — Sábado, 10:00h a 14:00h (cita previa)',
    },
    arreglos: {
      label: 'Arreglos Prêt-à-porter',
      schedule: 'Lunes — Viernes, 10:00h a 19:00h',
    },
    tienda: {
      label: 'Tienda Online',
      schedule: 'Consultas 24h por email. Respuesta en 24h',
    },
  },
  mapUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.2435!2d2.1650!3d41.3895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a2dd0c000001%3A0x0000000000000000!2sRambla%20de%20Catalunya%2C%20Barcelona!5e0!3m2!1ses!2ses!4v1700000000000!5m2!1ses!2ses',
  mapLink: 'https://maps.app.goo.gl/GSn4KTcECpHm5Q9u9',
};

export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '¿Cómo reservo una cita para alta costura?',
    answer: 'Puedes reservar una cita privada a través del formulario en la página de Alta Costura o contactándonos directamente por teléfono o email. Las consultas son martes a sábado en horario de mañana, siempre con cita previa. Durante la primera sesión conversaremos sobre tu visión, analizaremos referencias y comenzaremos el proceso creativo.',
  },
  {
    question: '¿Cuánto tiempo tarda un arreglo?',
    answer: 'Depende del tipo de arreglo. Los ajustes simples (bajos, ajustes de cintura) suelen estar listos en 3-5 días. Reparaciones más complejas (cambios de cierre, ajustes estructurales) pueden requerir hasta una semana. Si tienes urgencia, consúltanos: intentamos siempre adaptarnos a tus necesidades sin sacrificar la calidad.',
  },
  {
    question: '¿Hacéis envíos de la tienda online?',
    answer: 'Actualmente las piezas de alta costura requieren consulta previa y citas de prueba, por lo que no disponemos de envío automático para ese tipo de prenda. Para la cápsula prêt-à-porter, contacta con nosotros y gestionaremos el envío personalizado con seguro incluido.',
  },
  {
    question: '¿Cuál es el precio de un vestido de alta costura?',
    answer: 'Cada pieza de alta costura es única y se presupuesta individualmente según el diseño, los materiales, el grado de bordado y el tiempo de confección. Nuestros vestidos de gala parten desde 4.800€ y los de novia desde 7.200€. Durante la consulta inicial te presentamos un presupuesto detallado sin compromiso.',
  },
  {
    question: '¿Trabajáis con clientes internacionales?',
    answer: 'Sí. Aunque nuestro atelier está en Barcelona, trabajamos con clientas de toda España, Europa y América Latina. Para clientes internacionales ofrecemos consultas online iniciales y coordinamos las sesiones de prueba durante visitas a Barcelona. También podemos gestionar envíos de la cápsula prêt-à-porter a cualquier país.',
  },
  {
    question: '¿Ofrecéis servicio de asesoría de imagen?',
    answer: 'Sí. Durante la consulta de alta costura, la asesoría de imagen está incluida en el proceso: analizamos tu silueta, paleta de color, la ocasión y tu estilo personal para diseñar una prenda que realmente te represente. También ofrecemos sesiones de asesoría independientes para revisión de armario y compras personalizadas.',
  },
];